import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g fillOpacity="1">
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 -79.73 766.911)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 .0189 -28.915 764.98)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.01883 0 0 -.0189 171.243 1006.744)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 .05667 37.01 766.911)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 -79.73 1004.813)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        fill="#000"
                        stroke="none"
                        strokeWidth="3.181"
                        transform="matrix(.05649 0 0 -.05667 37.01 1004.813)"
                    >
                        <path d="M2406.706 536.549H2491.962V832.2339999999999H2406.706z"></path>
                        <path d="M2917.856 395.129c67.135 120.804 23.601 273.145-97.235 340.262-120.836 67.117-273.216 23.594-340.35-97.21-17.88-32.173-28.44-67.893-30.889-104.572-9.342 137.92-128.747 242.091-266.662 232.714-137.914-9.378-242.11-128.753-232.73-266.631 9.38-137.878 128.785-242.049 266.7-232.671 36.205 2.462 71.442 12.765 103.724 30.221-118.192-70.885-156.875-224.529-85.945-343.145 70.93-118.617 224.613-157.29 343.261-86.379 118.647 70.912 157.33 224.555 86.4 343.172-21.34 35.69-51.243 65.5-86.812 86.882 121.024-66.97 273.404-23.448 340.538 97.357z"></path>
                    </g>
                    <g
                        transform="scale(.93673 1.06755)"
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        wordSpacing="0"
                    >
                        <path
                            d="M28.418 706.772q0 .386-.147.754-.331.185-.7.185H15.754q-1.362 0-1.362-1.381 0-.22.037-.773.036-.552.036-.847 0-.644.276-.828.203-.13.902-.13h4.602v-2.834H9.92q-1.602 0-1.602-1.49 0-.259.055-.94.056-.7.056-1.104 0-.626.718-1.565l10.64-13.99q.496-.662 1.25-.662h2.43q.866 0 .866.957v15.02q.662 0 1.51-.036.864-.037 1.104-.037.994 0 1.233.497.24.479.24 2.393 0 .35-.056.534-.11.423-.847.423h-3.184v2.835q.68 0 1.546-.037.865-.037 1.086-.037 1.05 0 1.27.534.184.442.184 2.559zm-8.1-19.696q-1.011 1.546-7.473 10.069h7.4q0-.976-.037-3.35-.055-2.154-.036-3.37.018-1.84.147-3.35z"
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            fontSize="37.699"
                        ></path>
                    </g>
                    <g
                        transform="scale(-.93673 -1.06755)"
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        wordSpacing="0"
                    >
                        <path
                            d="M-221.388-952.85q0 .386-.147.754-.331.184-.7.184h-11.817q-1.362 0-1.362-1.38 0-.221.037-.773.036-.553.036-.847 0-.644.277-.828.202-.13.902-.13h4.601v-2.834h-10.326q-1.602 0-1.602-1.491 0-.258.056-.939.055-.7.055-1.104 0-.626.718-1.565l10.64-13.99q.496-.662 1.25-.662h2.43q.866 0 .866.957v15.02q.662 0 1.51-.036.864-.037 1.104-.037.994 0 1.233.497.24.478.24 2.393 0 .35-.056.534-.11.423-.847.423h-3.184v2.835q.68 0 1.546-.037.865-.037 1.086-.037 1.05 0 1.27.534.184.442.184 2.559zm-8.099-19.696q-1.012 1.546-7.473 10.068h7.4q0-.975-.037-3.35-.056-2.153-.037-3.368.018-1.841.147-3.35z"
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            fontSize="37.699"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
